import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';
import { Modal, Header } from 'semantic-ui-react';

import {
  dateSortMethod,
  formatSorted,
  formatFiltered,
} from 'Common/GridHelper';
import { PagingFilterTypeEnum } from 'Common/Constants/Enumeration/PagingFilterTypeEnum';

class TransactionHistoryGridContainer extends Component {
  state = {
    transactionId: '',
  };

  columns = [
    {
      Header: 'Effective Date',
      accessor: 'EffectiveDT',
      width: 200,
      sortMethod: dateSortMethod,
    },
    {
      Header: 'Actual Date',
      accessor: 'ActualDT',
      sortMethod: dateSortMethod,
    },
    {
      Header: 'Status',
      accessor: 'Status',
      width: 50,
    },
    {
      Header: 'Item #',
      accessor: 'ItemId',
      width: 50,
    },
    {
      Header: 'Description',
      accessor: 'Description',
      width: 250,
    },
    {
      Header: 'Purchase',
      accessor: 'Purchase',
      width: 70,
      className: 'rt-td--currency',
    },
    {
      Header: 'Payments',
      accessor: 'Payments',
      width: 70,
      className: 'rt-td--currency',
    },
    {
      Header: 'Check #',
      accessor: 'CheckNumber',
    },
    {
      Header: 'Bal. After',
      accessor: 'Balance',
      width: 60,
      className: 'rt-td--currency',
    },
    {
      Header: 'User',
      accessor: 'UserName',
    },
    {
      Header: 'Billing Acc #',
      accessor: 'BillingAcc',
    },
    {
      Header: 'Nut. Code',
      accessor: 'NutritionCode',
      width: 70,
    },
    {
      Header: 'Void User',
      accessor: 'vuser',
    },
    {
      Header: 'Void Date',
      accessor: 'VoidDT',
      width: 200,
      sortMethod: dateSortMethod,
    },
  ];

  currentTransactionId = null;
  currentClass = 'even';

  rowDataColorChange = (state, rowInfo, column, instance) => {
    if (rowInfo) {
      const { TransactionId, vuser } = rowInfo.original;
      if (
        !this.currentTransactionId ||
        this.currentTransactionId !== TransactionId
      ) {
        this.currentTransactionId = TransactionId;
        this.currentClass = this.currentClass === 'even' ? 'odd' : 'even';
      }
      return {
        className: this.currentClass + ' no-hover',
        style: { color: vuser !== null ? 'red' : '' },
      };
    }
    return { className: 'no-hover' };
  };

  onFetchTransactionData = (tableState) => {
    const { getData } = this.props;
    getData(
      tableState.page + 1,
      tableState.pageSize,
      formatSorted(tableState.sorted),
      formatFiltered(tableState.filtered, PagingFilterTypeEnum.MatchFromStart)
    );
  };

  render() {
    const {
      studentModalData,
      onClose,
      showHistoryModal,
      loading,
      transactionData,
      pages,
    } = this.props;

    return (
      <div>
        <Modal
          open={showHistoryModal}
          onClose={onClose}
          closeIcon
          size={'large'}
          closeOnRootNodeClick={false}
        >
          <Header
            content={`Meal History - ${
              studentModalData ? studentModalData.FirstName : ''
            } ${studentModalData ? studentModalData.LastName : ''}`}
            icon={'history'}
          />

          <Modal.Content className="p-t-0">
            <ReactTable
              data={Array.isArray(transactionData) ? transactionData : []}
              onFetchData={this.onFetchTransactionData}
              columns={this.columns}
              defaultPageSize={15}
              showPageSizeOptions={false}
              getTrProps={this.rowDataColorChange}
              sortable={true}
              filterable={false}
              resizable={true}
              loading={loading}
              noDataText=""
              manual={true}
              pages={pages}
            />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = ({ AccountSetupState }) => {
  return {
    transactionData: AccountSetupState.transactionHistory,
    loading: AccountSetupState.historyLoading,
  };
};

export const MealHistory = withRouter(
  connect(mapStateToProps, null)(TransactionHistoryGridContainer)
);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/TransactionHistoryGrid.js